import { gql } from '@apollo/client'

export const GET_ALL_BLOG_POSTS = gql`
  query GetAllBlogPosts(
    $searchQuery: String
    $limit: Int
    $offset: Int
    $filters: filtersBlogPost
  ) {
    getAllBlogPosts(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
      filters: $filters
    ) {
      rows {
        id
        layout
        category
        title
        content
        summary_content
        image_file_id
        image_file_url
        external_link
        external_link_label
        status_id
      }
      count
    }
  }
`

export const GET_ONE_BLOG_POST = gql`
  query GetOneBlogPost($id: Int!) {
    getOneBlogPost(id: $id) {
      id
      layout
      category
      title
      content
      summary_content
      image_file_id
      image_file_type
      image_file_url
      external_link
      external_link_label
      status_id
    }
  }
`

export const CREATE_BLOG_POST = gql`
  mutation CreateBlogPost($input: BlogPostInput!) {
    createBlogPost(input: $input)
  }
`

export const UPDATE_BLOG_POST = gql`
  mutation UpdateBlogPost($input: BlogPostInput!, $blogPostId: Int!) {
    updateBlogPost(input: $input, blogPostId: $blogPostId)
  }
`

export const DELETE_BLOG_POST = gql`
  mutation DeleteBlogPost($id: Int!) {
    deleteBlogPost(id: $id)
  }
`

export const UPDATE_BLOG_POST_ONLY_FILE = gql`
  mutation UpdateBlogPostOnlyFile(
    $blogPostId: Int!
    $input: BlogPostInputFile!
  ) {
    updateBlogPostOnlyFile(blogPostId: $blogPostId, input: $input)
  }
`

export const UPDATE_BLOG_POST_ONLY_FILE_DELETE = gql`
  mutation UpdateBlogPostOnlyFileDelete($blogPostId: Int!) {
    updateBlogPostOnlyFileDelete(blogPostId: $blogPostId)
  }
`
